import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { setAuthHeader, installAuthInterceptor } from "./utils/auth";
import { logout } from "./actions/adminActions";
import {
  thefirmCreateReducer,
  thefirmDeleteReducer,
  thefirmReducer,
  thefirmUpdateReducer,
} from "./reducers/thefirmReducers";
import { adminLoginReducer } from "./reducers/adminLoginReducer";
import {
  areaofexpertiseCreateReducer,
  areaofexpertiseDeleteReducer,
  areaofexpertiseReducer,
  areaofexpertiseUpdateReducer,
  singleExpertiseReducer,
} from "./reducers/areaofexpertiseReducer";
import {
  industrysectorCreateReducer,
  industrysectorDeleteReducer,
  industrysectorReducer,
  industrysectorUpdateReducer,
} from "./reducers/industrysectorReducer";
import {
  partnersCreateReducer,
  partnersDeleteReducer,
  partnersReducer,
  partnersUpdateReducer,
} from "./reducers/partnersReducers";
import {
  associatesCreateReducer,
  associatesDeleteReducer,
  associatesReducer,
  associatesUpdateReducer,
} from "./reducers/associatesReducer";
import {
  informationtechnologyCreateReducer,
  informationtechnologyDeleteReducer,
  informationtechnologyReducer,
  informationtechnologyUpdateReducer,
} from "./reducers/informationtechnologyReducer";
import {
  associatesPartnersCreateReducer,
  associatesPartnersDeleteReducer,
  associatesPartnersReducer,
  associatesPartnersUpdateReducer,
} from "./reducers/associatesPartnersReducers";
import {
  seniourAssociatesCreateReducer,
  seniourAssociatesDeleteReducer,
  seniourAssociatesReducer,
  seniourAssociatesUpdateReducer,
} from "./reducers/seniourAssociatesReducer";

const reducer = combineReducers({
  thefirmData: thefirmReducer,
  thefirmCreate: thefirmCreateReducer,
  thefirmUpdate: thefirmUpdateReducer,
  thefirmDelete: thefirmDeleteReducer,

  areaofexpertiseData: areaofexpertiseReducer,
  singleexpertiseData: singleExpertiseReducer,
  areaofexpertiseCreate: areaofexpertiseCreateReducer,
  areaofexpertiseUpdate: areaofexpertiseUpdateReducer,
  areaofexpertiseDelete: areaofexpertiseDeleteReducer,

  industrysectorData: industrysectorReducer,
  industrysectorCreate: industrysectorCreateReducer,
  industrysectorUpdate: industrysectorUpdateReducer,
  industrysectorDelete: industrysectorDeleteReducer,

  partnersData: partnersReducer,
  partnersCreate: partnersCreateReducer,
  partnersUpdate: partnersUpdateReducer,
  partnersDelete: partnersDeleteReducer,

  associatePartnersData: associatesPartnersReducer,
  associatePartnersCreate: associatesPartnersCreateReducer,
  associatePartnersDelete: associatesPartnersDeleteReducer,
  associatePartnersUpdate: associatesPartnersUpdateReducer,

  associatesData: associatesReducer,
  associatesCreate: associatesCreateReducer,
  associatesUpdate: associatesUpdateReducer,
  associatesDelete: associatesDeleteReducer,

  seniourAssociatesData: seniourAssociatesReducer,
  seniourAssociatesCreate: seniourAssociatesCreateReducer,
  seniourAssociatesUpdate: seniourAssociatesUpdateReducer,
  seniourAssociatesDelete: seniourAssociatesDeleteReducer,

  informationtechnologyData: informationtechnologyReducer,
  informationtechnologyCreate: informationtechnologyCreateReducer,
  informationtechnologyUpdate: informationtechnologyUpdateReducer,
  informationtechnologyDelete: informationtechnologyDeleteReducer,

  adminLogin: adminLoginReducer,
});

let adminInfoFromStorage = null;
try {
  adminInfoFromStorage = JSON.parse(localStorage.getItem("adminInfo")) || null;
} catch (e) {
  localStorage.removeItem("adminInfo");
}
// Send the admin token on every request from the first render (fixes requests
// made right after a page refresh going out without authentication).
setAuthHeader(adminInfoFromStorage && adminInfoFromStorage.token);

const initialState = {
  adminLogin: { adminInfo: adminInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

installAuthInterceptor(store, logout);

export default store;
